import { apiSlice } from "../../../app/apiSlice";

const apiSliceWithTags = apiSlice.enhanceEndpoints({
  addTagTypes: ["Subject"],
});

export const subjectApiSlice = apiSliceWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getSubjects: builder.query({
      query: (parameter) => `subject/${parameter}`,
      providesTags: ["Subject"],
    }),
    getSubjectsPaginated: builder.query({
      query: ({ page = 1, per_page = 20, q = "" } = {}) => ({
        url: `/subject/all`,
        params: { page, per_page, ...(q ? { q } : {}) },
      }),
      providesTags: ["Subject"],
    }),
    getSubjectClassrooms: builder.query({
      query: (subject_id) => `/subject/${subject_id}/classrooms`,
      providesTags: ["Subject", "Classes", "Teacher"],
    }),
    createSubject: builder.mutation({
      query: (values) => ({
        url: `/subject/create`,
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["Subject"],
    }),
    updateSubject: builder.mutation({
      query: (values) => ({
        url: `/subject/update`,
        method: "PUT",
        body: { ...values },
      }),
      invalidatesTags: ["Subject"],
    }),
    deleteSubject: builder.mutation({
      query: (values) => ({
        url: `/subject/${values.id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Subject"],
    }),
  }),
});

export const {
  useGetSubjectsQuery,
  useGetSubjectsPaginatedQuery,
  useGetSubjectClassroomsQuery,
  useCreateSubjectMutation,
  useUpdateSubjectMutation,
  useDeleteSubjectMutation,
} = subjectApiSlice;
